import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  SHOP_STATUS_OPEN_ONLINE,
  SHOP_STATUS_OPEN_OFFLINE,
  SHOP_STATUS_CLOSED_ONLINE,
  SHOP_STATUS_CLOSED_OFFLINE,
  SHOP_STATUS_CLOSED_ADHOC_ONLINE,
  SHOP_STATUS_CLOSED_ADHOC_OFFLINE,
} from '@chama/utils/constants/status';

const propTypes = {
  status: PropTypes.string.isRequired,
};

const ShopOpeningTimesStatusLabel = ({ status }) => {
  if (status === SHOP_STATUS_CLOSED_ADHOC_ONLINE) {
    return (
      <FormattedMessage
        id="shop_status.adhoc_closed_online"
        defaultMessage="Closed (adHoc) & Online"
      />
    );
  }

  if (status === SHOP_STATUS_CLOSED_ADHOC_OFFLINE) {
    return (
      <FormattedMessage
        id="shop_status.adhoc_closed_offline"
        defaultMessage="Closed (adHoc) & Offline"
      />
    );
  }

  if (status === SHOP_STATUS_OPEN_ONLINE) {
    return <FormattedMessage id="shop_status.open_online" defaultMessage="Open & Online" />;
  }

  if (status === SHOP_STATUS_OPEN_OFFLINE) {
    return <FormattedMessage id="shop_status.open_offline" defaultMessage="Open & Offline" />;
  }

  if (status === SHOP_STATUS_CLOSED_OFFLINE) {
    return <FormattedMessage id="shop_status.closed_offline" defaultMessage="Closed & Offline" />;
  }

  if (status === SHOP_STATUS_CLOSED_ONLINE) {
    return <FormattedMessage id="shop_status.closed_online" defaultMessage="Closed & Online" />;
  }

  return <span>N/A</span>;
};

ShopOpeningTimesStatusLabel.propTypes = propTypes;

export default ShopOpeningTimesStatusLabel;



// WEBPACK FOOTER //
// ./src/components/ShopOpeningTimesStatusLabel/index.jsx